<template>
  <section v-if="session && session.can_undo" class="boxes update-back-btn step-back-button">
    <b-row class="justify-content-md-center">
      <b-col md="4" lg="3" class="p-0">
        <b-button block @click="goBack()" class="btn-outline-success btn-back" variant="outline-success">Back</b-button>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'StepBackButton',
  computed: {
    ...mapState(['session'])
  },
  methods: {
    goBack: function() {
      this.$emit('back') // go back to the previous step (ignore changes to item selection)
    }
  }
}
</script>

<style scoped>
  .step-back-button {
    margin-top: 60px;
  }
</style>
